interface StatusTabProps {
  statuses: any[];
  onAdd: () => void;
  onEdit: (s: any) => void;
}

export function StatusTab({ statuses, onAdd, onEdit }: StatusTabProps) {
  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-text-primary">Status</h2>
        <button onClick={onAdd} className="px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700">
          + Add status
        </button>
      </div>
      <div className="border border-border-default rounded-md overflow-hidden">
        <table className="w-full border-collapse">
          <thead className="bg-background-secondary">
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Name</th>
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Color</th>
              <th className="text-right py-2 px-4 text-xs font-semibold text-text-secondary">Actions</th>
            </tr>
          </thead>
          <tbody>
            {statuses.map((s) => (
              <tr key={s.id} className="border-b border-gray-100 last:border-0 hover:bg-surface-hover">
                <td className="py-2 px-4">
                  <div className="flex items-center gap-2">
                    <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: s.color }} />
                    <span className="text-sm text-text-primary">{s.name}</span>
                  </div>
                </td>
                <td className="py-2 px-4 text-xs text-text-tertiary font-mono">{s.color}</td>
                <td className="py-2 px-4 text-right">
                  <button onClick={() => onEdit(s)} className="text-xs text-blue-600 hover:text-blue-700 font-medium">Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {statuses.length === 0 && (
          <p className="py-6 text-center text-sm text-text-secondary">No statuses yet.</p>
        )}
      </div>
    </div>
  );
}
